import { blogsAPI } from "../../api/blogs/blogsAPI";
import { helpCenterAPI } from "../../api/helpCenter/helpCenterAPI";

// => RTK middleware
export const RTKmiddleware = [blogsAPI.middleware, helpCenterAPI.middleware];
